import axios from 'axios';

export default (id) => {
  const promise = new Promise((resolve, reject) => {
    axios
      .get(`${process.env.VUE_APP_API_ADMIN_LOCATION}organizations/${id}`)
      .then(({ data }) => {
        console.log('data 1111', data);
        resolve(data);
        // if(params.page || params.per_page) {
        //   let dataRes = {};
        //   if (data.data) {
        //     dataRes.data = corporateTransformer.fetchCollection(data.data);
        //   }
        //   dataRes.meta = data.meta
        //     ? data.meta
        //     : tableUtil.mockupMeta(dataRes.data.length);
        //   resolve(dataRes);
        // } else {
        //   resolve(corporateTransformer.fetchCollection(data.data));
        // }
      })
      .catch((error) => {
        reject(error);
      });
  });

  return promise;
};
